import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { dmOfferType }                           from '../offertypes/xv-offertypes';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmDiscountType {
    DiscountTypeID:   number;
    DiscountTypeName: string;

    constructor(
         pDiscountTypeID:   number
        ,pDiscountTypeName: string
    ) {
        this.DiscountTypeID   = pDiscountTypeID;
        this.DiscountTypeName = pDiscountTypeName;
    }
}

export class EarlyBirdViewModel {
    ShowAlert:                   (pTitle: string, pMessage: string) => void;
    BackToSignIn:                ()                                 => void;
    NewLoading:                  (pMessage: string)                 => dmLoading;

    mlText:                      MLText;
    app:                         mlBroker;
    ml:                          mlBroker;
    Hotel:                       dmHotel;
    LangID:                      number;

    InAction:                    boolean;

    PackageLevelAdvanceDays:     number;

    SelectedSourceOfferTypeID:   number;
    DiscountTypeID:              number;

    IsSurcharge:                 boolean;
    IsSurchargeLabel:            string;

    Surcharge:                   number;
    SourceMLOS:                  boolean;
    SourceMaxStay:               boolean;
    SourceNoArr:                 boolean;
    SourceNoDep:                 boolean;

    SourceOfferTypes:            dmOfferType[];
    SourceOfferTypesByID:        dmOfferType[];
    DiscountTypes:               dmDiscountType[];
    DiscountTypesByID:           dmDiscountType[];

    EarlyBirdActive:             boolean;
    EarlyBirdOfferTypeID:        number;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText       = pMLText;
        this.LangID       = this.mlText.GetLangID();
        this.app          = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml           = this.mlText.GetBroker(
            'HotelAreaEarlyBird'
        );

        this.Hotel        = pHotel;
        this.BackToSignIn = pBackToSignIn;
        this.ShowAlert    = pShowAlert;
        this.NewLoading   = pNewLoading;

        this.InAction                    = true;

        this.SelectedSourceOfferTypeID   = 0;
        this.DiscountTypeID              = 0;

        this.IsSurcharge                 = false;
        this.IsSurchargeLabel            = this.ml.Text('DiscountAmount' ,'Discount Amount');

        this.Surcharge                   = 0;
        this.SourceMLOS                  = true;
        this.SourceMaxStay               = false;
        this.SourceNoArr                 = false;
        this.SourceNoDep                 = false;

        this.PackageLevelAdvanceDays     = 0;

        this.SourceOfferTypes            = [];
        this.SourceOfferTypesByID        = [];
        this.DiscountTypes               = [];
        this.DiscountTypesByID           = [];

        let percentageType: dmDiscountType = new dmDiscountType(
             0
            ,this.ml.Text('PercentageModifier'  ,'Percentage Modifier')
        );

        let fixedType:      dmDiscountType = new dmDiscountType(
             1
            ,this.ml.Text('FixedPricePerPerson' ,'Fixed Price Per Person')
        );

        this.DiscountTypes.push(percentageType);
        this.DiscountTypes.push(fixedType);

        this.DiscountTypesByID[0] = percentageType;
        this.DiscountTypesByID[1] = fixedType;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let paymentSchemeParams = RQParam.PmsGetPaymentSchemesOTAParams();

            paymentSchemeParams.LangID = this.LangID;

            let offerTypesParams = RQParam.PmsGetOfferTypesParams();

            offerTypesParams.HotelID = this.Hotel.HotelID;
            offerTypesParams.LangID  = this.LangID;

            RQService.Pms.GetOfferTypes(offerTypesParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let offerTypes = response.RQueryResult;

                for (let i = 0; i < offerTypes.length; i++) {
                    let offerType = new dmOfferType(
                        RQService.Pms.PopulateGetOfferTypesRow(
                            offerTypes[i]
                        )
                    );

                    if (offerType.OfferType.IsDiscountFilter == 0) {
                        console.log('row push');

                        this.SourceOfferTypes.push(offerType);

                        this.SourceOfferTypesByID[
                            offerType.OfferType.OfferTypeID
                        ] = offerType;
                    }
                }

                let earlyBirdParams = RQParam.PmsGetEarlyBirdOfferTypeParams();

                earlyBirdParams.HotelID = this.Hotel.HotelID;
                earlyBirdParams.LangID  = this.LangID;

                RQService.Pms.GetEarlyBirdOfferType(earlyBirdParams).then((result) => {
                    let response = result as any;

                    if (response.HasErrorOrException) { loading.Dismiss(); return; }

                    let earlyBirdResult = response.RQueryResult;

                    if (earlyBirdResult.length > 0) {
                        let earlyBird = RQService.Pms.PopulateGetEarlyBirdOfferTypeRow(
                            earlyBirdResult[0]
                        );

                        this.EarlyBirdActive           = true;
                        this.EarlyBirdOfferTypeID      = earlyBird.OfferTypeID;

                        this.SelectedSourceOfferTypeID = earlyBird.SourceOfferTypeID;
                        this.DiscountTypeID            = earlyBird.DiscountTypeID;

                        this.IsSurcharge               = (earlyBird.Surcharge > 0);

                        if (this.IsSurcharge) {
                            this.IsSurchargeLabel = this.ml.Text(
                                 'SurchargeAmount'
                                ,'Surcharge Amount'
                            );
                        } else {
                            this.IsSurchargeLabel = this.ml.Text(
                                 'DiscountAmount'
                                ,'Discount Amount'
                            );
                        }

                        this.Surcharge                 = (this.IsSurcharge)
                                                       ? (earlyBird.Surcharge)
                                                       : ((-1) * earlyBird.Surcharge);

                        this.SourceMLOS                = (earlyBird.SourceMLOS    != 0);
                        this.SourceMaxStay             = (earlyBird.SourceMaxStay != 0);
                        this.SourceNoArr               = (earlyBird.SourceNoArr   != 0);
                        this.SourceNoDep               = (earlyBird.SourceNoDep   != 0);

                        this.PackageLevelAdvanceDays   = earlyBird.PackageLevelAdvanceDays;
                    } else {
                        if (this.SourceOfferTypes.length == 1) {
                            this.SelectSourceOfferType(
                                this.SourceOfferTypes[0].OfferType.OfferTypeID
                            );
                        }

                        this.EarlyBirdActive      = false;
                        this.EarlyBirdOfferTypeID = 0;
                    }

                    loading.Dismiss();

                    this.InAction = false;
                });
            });
        });
    }

    public SelectSourceOfferType(pSourceOfferTypeID: number) {
        this.SelectedSourceOfferTypeID = pSourceOfferTypeID;
    }

    public SelectDiscountType(pDiscountTypeID: number) {
        this.DiscountTypeID = pDiscountTypeID;
    }

    public SelectIsSurcharge() {
        if (this.IsSurcharge) {
            this.IsSurchargeLabel = this.ml.Text('SurchargeAmount' ,'Surcharge Amount');
        } else {
            this.IsSurchargeLabel = this.ml.Text('DiscountAmount'  ,'Discount Amount');
        }
    }

    private deleteOfferType(
         pOfferTypeID: number
        ,pPredicate:   (pWithError: boolean) => void
    ) {
        if (!this.EarlyBirdActive) { pPredicate(false); return; }
            
        let deleteParams = RQParam.PmsDeleteOfferTypeParams();
        
        deleteParams.HotelID     = this.Hotel.HotelID;
        deleteParams.OfferTypeID = this.EarlyBirdOfferTypeID;
        deleteParams.LangID      = this.LangID;
        
        RQService.Pms.DeleteOfferType(deleteParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pPredicate(true); return; }

            this.EarlyBirdActive      = false;
            this.EarlyBirdOfferTypeID = 0;

            pPredicate(false);
        });
    }

    public addOfferType(
        pPredicate: (pWithError: boolean) => void
    ) {
        if (this.EarlyBirdActive) { pPredicate(true); return; }

        let addParams = RQParam.PmsNewOfferTypeAsDiscountOTAParams();
        
        addParams.HotelID                    = this.Hotel.HotelID;
        addParams.RackRatePaymentSchemeID    = 1;
        addParams.Credentials                = '';
        addParams.ReleaseDays                = 0;
        addParams.CancelConsumesAvailability = 0;
        addParams.OfferTypeName              = '';
        addParams.OfferTypeDescription       = '';
        addParams.OfferTypeAutoNameID        = 5;
        addParams.SourceOfferTypeID          = this.SelectedSourceOfferTypeID;
        addParams.DiscountTypeID             = this.DiscountTypeID;
        addParams.Surcharge                  = (this.IsSurcharge)
                                             ? this.Surcharge
                                             : (-1) * this.Surcharge;
        addParams.SourceMLOS                 = (this.SourceMLOS)        ? 1 : 0;
        addParams.SourceMaxStay              = (this.SourceMaxStay)     ? 1 : 0;
        addParams.SourceAdvanceDays          = 0;
        addParams.SourceNoArr                = (this.SourceNoDep)       ? 1 : 0;
        addParams.SourceNoDep                = (this.SourceNoDep)       ? 1 : 0;
        addParams.SourceMaxPersons           = 0;
        addParams.InitialiseAllotmentToZero  = 0;
        addParams.PackageLevelAdvanceDays    = this.PackageLevelAdvanceDays;
        addParams.LangID                     = this.LangID;

        RQService.Pms.NewOfferTypeAsDiscountOTA(addParams).then((result) => {
            let response = result as any;
        
            if (response.HasErrorOrException) {
                pPredicate(true);
        
                return;
            }

            let newOfferTypeID: number = 0;

            let status = response.RQueryResult;

            if (
                (status.length > 0)
            &&  (status[0].ReturnValue)
            &&  (!isNaN(Number(status[0].ReturnValue)))
            ) {
                newOfferTypeID = Number(status[0].ReturnValue);
            }

            this.EarlyBirdActive      = true;
            this.EarlyBirdOfferTypeID = newOfferTypeID;

            pPredicate(false);
        });
    }

    public DeactivateEarlyBird(): void {
        if ((this.InAction) || (!this.EarlyBirdActive)) { return; }

        this.InAction = true;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            this.deleteOfferType(this.EarlyBirdOfferTypeID, (pWithError: boolean) => {
                if (!pWithError) {
                    if (this.SourceOfferTypes.length == 1) {
                        this.SelectSourceOfferType(
                            this.SourceOfferTypes[0].OfferType.OfferTypeID
                        );
                    } else {
                        this.SelectedSourceOfferTypeID = 0;
                    }

                    this.DiscountTypeID            = 0;

                    this.IsSurcharge               = false;
                    this.IsSurchargeLabel          = this.ml.Text(
                         'DiscountAmount'
                        ,'Discount Amount'
                    );

                    this.Surcharge                 = 0;
                    this.SourceMLOS                = true;
                    this.SourceMaxStay             = false;
                    this.SourceNoArr               = false;
                    this.SourceNoDep               = false;

                    this.PackageLevelAdvanceDays   = 0;
                }

                loading.Dismiss();

                this.InAction = false;
            });
        });
    }

    public EditEarlyBird(): void {
        if (this.InAction) { return; }

        if (this.SelectedSourceOfferTypeID == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'NoParentPackageSelected'
                    ,'No parent package selected'
                )
            );

            return;
        }

        if (this.Surcharge == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'SurchargeOrDiscountEmpty'
                    ,'Surcharge/Discount is empty'
                )
            );

            return;
        }

        if (this.PackageLevelAdvanceDays <= 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'DaysInAdvanceMustBeMoreThanZero'
                    ,'Days in advance for early bird rate must be more than zero'
                )
            );

            return;
        }

        this.InAction = true;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            if (this.EarlyBirdActive) {
                this.deleteOfferType(this.EarlyBirdOfferTypeID, (pWithError: boolean) => {
                    if (pWithError) {
                        loading.Dismiss();

                        this.InAction = false;

                        return;
                    }

                    this.addOfferType((pWithError: boolean) => {
                        loading.Dismiss();

                        this.InAction = false;

                        return;
                    });
                });
            } else {
                this.addOfferType((pWithError: boolean) => {
                    loading.Dismiss();

                    this.InAction = false;

                    return;
                });
            }
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/earlybird/xv-earlybird.ts